<script>
import UserData from '@/mixins/UserData';

export default {
	mixins: [UserData],
	computed: {
		selectedFacility() {
			return this.$store.getters.selectedFacility;
		},
		selectedFacilityId() {
			return this.selectedFacility ? this.selectedFacility.facility_ID : null;
		}
	}
};
</script>
